(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* FAQ accordion */
  qsa('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      if (!item) return;
      var open = item.classList.contains('open');
      qsa('.faq-item.open').forEach(function (el) { el.classList.remove('open'); });
      if (!open) item.classList.add('open');
    });
  });

  /* Mobile nav */
  var menuToggle = qs('[data-menu-toggle]');
  var nav = qs('nav.main-nav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Search drawer */
  var searchToggle = qs('[data-search-toggle]');
  var searchDrawer = qs('[data-search-drawer]');
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function () {
      searchDrawer.classList.toggle('open');
      var input = qs('input', searchDrawer);
      if (searchDrawer.classList.contains('open') && input) input.focus();
    });
  }

  /* Cart count from Shopify Cart AJAX API */
  function setCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  window.CloserCards = window.CloserCards || {};
  window.CloserCards.refreshCartCount = refreshCartCount;
  window.CloserCards.setCartCount = setCartCount;

  /* AJAX add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-add-to-cart]')) return;
    if (form.getAttribute('data-no-ajax') === 'true') return;
    e.preventDefault();

    var btn = qs('[type="submit"]', form);
    var status = qs('[data-add-status]', form) || qs('[data-add-status]', form.parentElement);
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    if (status) { status.textContent = ''; status.classList.remove('error'); }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function () {
        refreshCartCount();
        if (form.classList.contains('product-form')) {
          if (status) status.textContent = 'Added — taking you to checkout…';
          window.location.href = '/cart';
          return;
        }
        if (btn) btn.textContent = 'Added ✓';
        if (status) status.textContent = 'Added to cart';
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        }, 1400);
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart';
        if (status) { status.textContent = msg; status.classList.add('error'); }
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty-wrap');
    if (!wrap) return;
    var input = qs('input[type="number"]', wrap);
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var val = parseInt(input.value || '1', 10);
    if (isNaN(val)) val = min;
    if (btn.getAttribute('data-qty') === 'plus') val += 1;
    if (btn.getAttribute('data-qty') === 'minus') val = Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Create-card previews + size/duration checks (Shopify file props ~20MB) */
  var MAX_FILE = 20 * 1024 * 1024;
  var MAX_VIDEO_SEC = 90.5;

  function formatDuration(sec) {
    if (!isFinite(sec) || sec < 0) return '0:00';
    var s = Math.floor(sec);
    var m = Math.floor(s / 60);
    var r = s % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function bindDropZone(zone, input) {
    if (!zone || !input) return;
    function openPicker() { input.click(); }
    zone.addEventListener('click', function (e) {
      if (e.target === input) return;
      openPicker();
    });
    zone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openPicker();
      }
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) {
        e.preventDefault();
        e.stopPropagation();
        zone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) {
        e.preventDefault();
        e.stopPropagation();
        zone.classList.remove('is-dragover');
      });
    });
    zone.addEventListener('drop', function (e) {
      var files = e.dataTransfer && e.dataTransfer.files;
      if (!files || !files.length) return;
      try {
        var dt = new DataTransfer();
        dt.items.add(files[0]);
        input.files = dt.files;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) {
        /* Fallback: user can click to pick */
      }
    });
  }

  function bindCreateCard(form) {
    var photo = qs('[data-card-photo]', form);
    var video = qs('[data-card-video]', form);
    var text = qs('[data-card-text]', form);
    var count = qs('[data-text-count]', form);
    var previewLine = qs('[data-preview-line]');
    var photoImg = qs('[data-photo-preview-img]');
    var galleryDefault = qs('[data-gallery-default]');
    var videoPrev = qs('[data-video-preview]', form);
    var addBtn = qs('[data-add-btn]', form) || qs('[type="submit"]', form);
    var shipInput = qs('[data-ship-to]', form);
    var videoOk = true;
    var defaultPhotoSrc = photoImg ? photoImg.getAttribute('src') : '';

    var photoZone = qs('[data-drop-zone="photo"]', form);
    var videoZone = qs('[data-drop-zone="video"]', form);
    bindDropZone(photoZone, photo);
    bindDropZone(videoZone, video);

    function setZoneFilled(zone, filled) {
      if (!zone) return;
      zone.classList.toggle('has-file', !!filled);
      var empty = qs('[data-drop-empty]', zone);
      var filledEl = qs('[data-drop-filled]', zone);
      if (empty) empty.hidden = !!filled;
      if (filledEl) filledEl.hidden = !filled;
    }

    function setAddEnabled() {
      if (!addBtn) return;
      if (addBtn.textContent && /sold out/i.test(addBtn.textContent)) return;
      addBtn.disabled = !videoOk;
    }

    /* Text counter + live preview line */
    if (text) {
      var syncText = function () {
        var v = String(text.value || '').slice(0, 80);
        if (text.value !== v) text.value = v;
        if (count) count.textContent = String(v.length);
        if (previewLine) previewLine.textContent = v || 'Happy birthday…';
      };
      text.addEventListener('input', syncText);
      syncText();
    }

    /* Photo drop */
    if (photo) {
      photo.addEventListener('change', function () {
        var file = photo.files && photo.files[0];
        if (!file) {
          setZoneFilled(photoZone, false);
          if (photoImg && defaultPhotoSrc) photoImg.src = defaultPhotoSrc;
          return;
        }
        if (file.size > MAX_FILE) {
          alert('That photo is a bit large for upload (Shopify allows about 20MB). Try a smaller image or WebP.');
          photo.value = '';
          setZoneFilled(photoZone, false);
          return;
        }
        var url = URL.createObjectURL(file);
        if (photoImg) photoImg.src = url;
        var thumb = photoZone && qs('[data-photo-thumb]', photoZone);
        var nameEl = photoZone && qs('[data-photo-name]', photoZone);
        if (thumb) thumb.src = url;
        if (nameEl) nameEl.textContent = file.name;
        setZoneFilled(photoZone, true);
      });
    }

    /* Video drop + duration gate */
    if (video) {
      video.addEventListener('change', function () {
        var file = video.files && video.files[0];
        var errEl = videoZone && qs('[data-video-error]', videoZone);
        var durEl = videoZone && qs('[data-video-duration]', videoZone);
        var meter = videoZone && qs('[data-video-meter]', videoZone);
        var nameEl = videoZone && qs('[data-video-name]', videoZone);
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        videoOk = true;
        setAddEnabled();

        if (!file) {
          setZoneFilled(videoZone, false);
          if (videoPrev) { videoPrev.removeAttribute('src'); videoPrev.hidden = true; }
          return;
        }
        if (file.size > MAX_FILE) {
          alert('That video is a bit large for upload (Shopify allows about 20MB). Compress it a bit, or use a shorter clip.');
          video.value = '';
          setZoneFilled(videoZone, false);
          videoOk = false;
          setAddEnabled();
          return;
        }

        if (nameEl) nameEl.textContent = file.name;
        setZoneFilled(videoZone, true);
        if (durEl) durEl.textContent = 'Reading duration…';

        var url = URL.createObjectURL(file);
        var probe = document.createElement('video');
        probe.preload = 'metadata';
        probe.onloadedmetadata = function () {
          var dur = probe.duration;
          if (dur > MAX_VIDEO_SEC) {
            videoOk = false;
            setAddEnabled();
            var msg = 'This video is ' + formatDuration(dur) + ' — max is 1:30. Choose a shorter clip to add to cart.';
            if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
            if (durEl) durEl.textContent = formatDuration(dur) + ' / 1:30';
            if (meter) {
              meter.hidden = false;
              var fill = qs('span', meter);
              if (fill) fill.style.width = '100%';
              meter.classList.add('is-over');
            }
            video.value = '';
            URL.revokeObjectURL(url);
            if (videoPrev) { videoPrev.removeAttribute('src'); videoPrev.hidden = true; }
            return;
          }
          videoOk = true;
          setAddEnabled();
          if (durEl) durEl.textContent = formatDuration(dur) + ' / 1:30';
          if (meter) {
            meter.hidden = false;
            meter.classList.remove('is-over');
            var fill2 = qs('span', meter);
            if (fill2) fill2.style.width = Math.min(100, (dur / 90) * 100) + '%';
          }
          if (videoPrev) {
            videoPrev.src = url;
            videoPrev.hidden = true;
          }
        };
        probe.onerror = function () {
          if (durEl) durEl.textContent = 'Could not read duration — we’ll still accept MP4/MOV under 90s.';
          videoOk = true;
          setAddEnabled();
        };
        probe.src = url;
      });
    }

    /* Send to pills */
    qsa('[data-send-toggle] [data-ship]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('[data-send-toggle] [data-ship]', form).forEach(function (b) {
          b.classList.remove('on');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('on');
        btn.setAttribute('aria-pressed', 'true');
        if (shipInput) shipInput.value = btn.getAttribute('data-ship') || 'them';
      });
    });

    form.addEventListener('submit', function (e) {
      if (!photo || !photo.files || !photo.files[0]) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('Add the photo that will be printed on the card.');
        return;
      }
      if (!video || !video.files || !video.files[0]) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('Add the video they will watch (MP4 or MOV, up to 90 seconds).');
        return;
      }
      if (!videoOk) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('Video can be up to 90 seconds. Choose a shorter clip.');
        return;
      }
      if (!text || !String(text.value || '').trim()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('Add a short line of text for the card.');
        return;
      }
    }, true);
  }

  qsa('form.product-form').forEach(bindCreateCard);

  refreshCartCount();
})();
